import React, { Fragment, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Col, Button } from 'reactstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';

export default function ResendEmail(props) {
    const history = useHistory();
    const { toggleLoading } = useAuth();
    const { match } = props;

    const [message, setMessage] = useState('Your account has been created! We sent you an email for your protection. Please, check your inbox (and spam folder), and click on the link in the email to confirm. ');

    const submitResendEmail = useCallback(
        async () => {
            toggleLoading(true);
            await api
                .post(`/ro.team.resendVerifyEmail`, {
                    email: match.params.email
                })
                .then(() => {
                    setMessage('Success! Access your email and click in the confirmation link to access Senior.Link. Please check your email and SPAM folder');
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [match.params.email, toggleLoading, setMessage]
    );

    const backToLogin = useCallback(
        async () => {
            history.push('/');
        },
        [history]
    );

    return (
        <Fragment>
            <div className="h-100 bg-animation">
                <div className="d-flex h-100 justify-content-center align-items-center">
                    <Col md="8" className="mx-auto app-login-box">
                        <div className="app-logo-inverse mx-auto mb-3" />

                        <div className="modal-dialog w-100">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="h5 modal-title text-center">
                                        <h4 className="mt-2">
                                            <span>
                                                {message}
                                            </span>
                                        </h4>
                                    </div>
                                </div>
                                <div className="modal-footer d-block text-center">
                                    <Button
                                        color="primary"
                                        className="btn-wide btn-pill btn-shadow btn-hover-shine mb-2 mr-2"
                                        size="lg"
                                        onClick={submitResendEmail}
                                    >
                                        Resend confirmation email
                                    </Button>
                                    <Button
                                        color="secondary"
                                        className="btn-wide btn-pill btn-shadow btn-hover-shine mb-2 mr-2"
                                        size="lg"
                                        onClick={backToLogin}
                                    >
                                        Login page
                                    </Button>
                                </div>
                            </div>
                        </div>
                        {/* <div className="text-center text-white opacity-8 mt-3">
                            Copyright &copy; ArchitectUI 2019
                        </div> */}
                    </Col>
                </div>
            </div>
        </Fragment>
    );
}
